import QRCode from 'qrcode'
import { useRef,useEffect } from 'react';
import { useParams } from 'react-router-dom'

export default function Page(props) {

    const { id } = useParams();

    const qrRef = useRef(null)

    const qrOptions = {
        scale: 8, 
        color: {
            dark: '#000',  // Blue dots
            light: '#FFFFFF' // Transparent background
        }
    }

    async function genQR(){
        QRCode.toCanvas(qrRef.current, id  , qrOptions, function (error) {
            if (error) console.error(error)
          })
    }

    useEffect(() => {
        genQR();
    },[id])

    return(
        <div className="w-full h-full flex flex-col gap-[16px] p-[16px] box-border">
            <div className="flex flex-col items-center justify-center flex-1 gap-[16px]">
                <div className='text-black text-[24px] font-bold'>請出示二維碼供店員掃描</div>
                <canvas ref={qrRef}/>
                <div className='text-black text-[24px] font-bold'>{id}</div>
            </div>
        </div>
    )
}